import { select, takeEvery } from 'redux-saga/effects'

import { DID } from 'app/constants/identityActions'
import {
  activityActions,
  getIdentityProgress,
  subscribeToProTrack,
  unsubscribeProgress,
} from 'store/entities/identity/actions'
import {
  activeProTrackLevel,
  getIdentityActiveProTrackId,
  getIdentityActiveProTrackName,
} from 'store/entities/identity/selectors'
import { CATEGORIES, PROTRACK_ACTIONS } from 'app/constants/analytics'
import * as stages from 'app/constants/stages'
import { googleTrack } from '../googleAnalytics'

export default function* pageviewSaga() {
  yield takeEvery(
    [
      getIdentityProgress.success.toString(),
      subscribeToProTrack.success.toString(),
      unsubscribeProgress.success.toString(),
      activityActions.commit.toString(),
      activityActions.did.toString(),
      activityActions.didnot.toString(),
    ],
    handleCreateEvent
  )
}

export function* handleCreateEvent({ payload, type }) {
  try {
    switch (type) {
      case getIdentityProgress.success.toString(): {
        const { data } = payload
        let { organization, action, stage, proTrack } = data
        if (action) {
          let category = CATEGORIES.ACTIVITY
          if (action === DID && stage === stages.DONE) {
            category = CATEGORIES.PROTRACK
            action = PROTRACK_ACTIONS.FINISHED
          }
          googleTrack(category, action, proTrack.name, organization.name)
        }
        break
      }
      case subscribeToProTrack.success.toString(): {
        const currentProTrack = yield select(activeProTrackLevel)
        const data = {
          action: PROTRACK_ACTIONS.STARTED, // **<- one of these values based on what the action is**
          protrackId: currentProTrack.id,
          protrackName: currentProTrack.name,
        }
        googleTrack(CATEGORIES.PROTRACK, PROTRACK_ACTIONS.STARTED, data)
        break
      }
      case unsubscribeProgress.success.toString(): {
        const data = {
          action: PROTRACK_ACTIONS.STOPPED,
          protrackId: yield select(getIdentityActiveProTrackId),
          protrackName: yield select(getIdentityActiveProTrackName),
        }
        googleTrack(CATEGORIES.PROTRACK, PROTRACK_ACTIONS.STOPPED, data)
        break
      }
      default:
        break
    }
  } catch (error) {
    console.log(`Analytics handleCreateEvent fail, action type is ${type}`, error)
  }
}
